import { useMatches } from 'react-router-dom';

export function useGetClosestHandle<T>(): T | null {
	const matches = useMatches();
	const handles = matches.filter(match => Boolean(match.handle as T)).map(match => match.handle as T);
	if (handles.length === 0) {
		return null;
	}
	return handles[handles.length - 1];
}
